

export const getAPIErrorMessage = (e: any, defaultMessage?: string): string => {
   return e?.original?.response?.data?.message || defaultMessage || '';
};